import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import {
  AccountsApi,
  RequestStrategyEnum,
  type GetCardAccountBalanceReportRequest,
  type CardAccountBalanceReportResponse,
  type WithSignal,
} from '@shared/api';

const getCardAccountBalanceReportEffect = createEffect(({ signal, ...request }: WithSignal<GetCardAccountBalanceReportRequest> = {}) =>
  AccountsApi.getCardAccountBalanceReport(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ total: number; data: CardAccountBalanceReportResponse[] }>({ data: [], total: 0 })
  .on(getCardAccountBalanceReportEffect.done, (_, data) =>
    data.result ? { total: data.result.total, data: data.result.data || [] } : { total: 0, data: [] },
  )
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getCardAccountBalanceReportEffect.pending, (_, data) => data)
  .on(getCardAccountBalanceReportEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getCardAccountBalanceReportEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getCardAccountBalanceReportEffect, () => null)
  // .on(getCardAccountBalanceReportEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getCardAccountBalanceReportEffect.fail, () => 'Something went wrong while fetching Accounts Balance. Please try again.')
  .on(getCardAccountBalanceReportEffect.done, () => null)
  .reset(clearEvent);

const getCardAccountBalanceReportApi = ApiUtils.wrapperApi(getCardAccountBalanceReportEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getCardAccountBalanceReportApi.cancel());

export const $accountCardReportStore = {
  events: {
    getCardAccountBalanceReport: getCardAccountBalanceReportApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
